import { PaletteMode } from '@mui/material';
import {
  colors,
  ColorPrimitives,
  extendedColors,
  materialColors,
  translucentColors,
} from '../primitives';
import { aiColors, exoColors } from './exosphere';

// Each legacy color points to the Exosphere role of its most common use, or,
// when uses are mixed, the role closest to its value. Roles that need another
// Exosphere role are overridden by meaning in `semantic.ts`.
export const getBoomiPrimitives = (mode: PaletteMode): ColorPrimitives => {
  const exo = exoColors[mode];
  const ai = aiColors[mode];
  const legacy: typeof colors = {
    white: exo.background,
    black: exo.font,
    gray: exo['border-secondary'],
    gray1: exo.border,
    gray2: exo['font-secondary'],
    gray3: exo['background-secondary'],
    gray4: exo['font-secondary'],
    gray5: exo['border-secondary'],
    gray6: exo['background-secondary'],
    gray7: exo['border-contrast'],
    gray8: exo['border-secondary'],
    gray9: exo['background-secondary'],
    gray10: exo['background-secondary'],
    gray11: exo['font-secondary'],
    gray12: exo['font-secondary'],
    gray13: exo['border-secondary'],
    gray14: exo.border,
    gray15: exo['background-secondary'],
    gray16: exo['border-secondary'],
    gray17: exo.border,
    gray18: exo['border-contrast'],
    slate: exo['font-secondary'],
    yellow: exo['set-1-3'],
    orange: exo['background-warning-strong'],
    orange2: exo['background-highlight'],
    lightOrange: exo['background-warning'],
    lightOrange2: exo['background-warning'],
    red: exo['font-danger'],
    red2: exo['font-danger'],
    lightRed: exo['background-danger-weak'],
    lightRed2: exo['background-danger-weak'],
    lightTurqoise: exo['background-success'],
    lightTurqoise2: exo['background-success'],
    green: exo['data-solid-green'],
    lightGreen: exo['background-success'],
    darkGreen: exo['font-success'],
    blue: exo['background-selected'],
    blue2: exo['background-selected-weak'],
    blue3: exo['background-selected'],
    blue4: exo['background-selected'],
    blue5: exo['background-selected'],
    blue6: exo['background-selected'],
    blue7: exo['background-selected'],
    lightBlue: exo['background-selected-weak'],
    lightBlue2: exo['background-selected-weak'],
    lightBlue3: exo['background-selected-weak'],
    lightBlue4: exo['background-selected-weak'],
    lightBlue5: exo['background-selected-weak'],
    lightBlue6: exo['background-selected-weak'],
    purple: ai['ai/accent-muted'],
    lightPurple: exo['background-selected-weak'],
    pink: ai['ai/accent-soft'],
    magenta: ai['ai/accent'],
    // 5% alpha is below the lowest Exosphere opacity step.
    magentaOpacity5: colors.magentaOpacity5,
    lightMagenta: ai['ai/surface-subtle'],
    blackOpacity5: colors.blackOpacity5,
    lightPink: ai['ai/surface-faint'],
    red10: exo['background-danger-weak'],
    red100: exo['font-danger'],
    orange10: exo['background-warning'],
    orange100: exo['background-warning-strong'],
    attentionYellow: exo['background-warning'],
    green10: exo['background-success'],
    green100: exo['font-success'],
    green200: exo['background-success'],
    jetGrey: exo['set-2-2'],
    lightGrey: colors.lightGrey,
  };

  return {
    colors: legacy,
    extendedColors: {
      ...extendedColors,
      aiGradientPink: ai['ai/gradient-pink'],
      aiGradientRose: ai['ai/gradient-rose'],
      aiGradientBlue: ai['ai/gradient-blue'],
      neutral240: legacy.gray8,
      neutral235: legacy.gray13,
      neutral248: legacy.gray10,
      neutral238: legacy.gray5,
      neutral254: legacy.white,
      lightBlueAlice: legacy.lightBlue6,
      scrollbarThumb: legacy.gray14,
      pureWhite: legacy.white,
    },
    translucentColors,
    materialColors,
  };
};
